import { useEffect, useId, useRef, type ReactNode } from 'react';

/** Modal built on <dialog>: focus trapping, Esc to close, backdrop click to close. */
export function Dialog({
  open,
  onClose,
  title,
  children,
}: {
  open: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
}) {
  const ref = useRef<HTMLDialogElement>(null);
  const titleId = useId();
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (open && !el.open) el.showModal();
    else if (!open && el.open) el.close();
  }, [open]);
  return (
    <dialog
      ref={ref}
      onClose={onClose}
      onClick={(e) => {
        if (e.target === ref.current) onClose();
      }}
      aria-labelledby={titleId}
      className="m-auto w-[min(92vw,28rem)] animate-rise rounded-2xl border border-line bg-surface p-0 text-ink shadow-[var(--shadow-lift)] backdrop:bg-ink/45 backdrop:backdrop-blur-[2px]"
    >
      <div className="flex flex-col gap-4 p-5" onClick={(e) => e.stopPropagation()}>
        <h2 id={titleId} className="flex items-center gap-2.5 text-lg font-bold">
          <span aria-hidden className="h-5 w-1.5 shrink-0 rounded-full bg-accent" />
          {title}
        </h2>
        {children}
      </div>
    </dialog>
  );
}
